import { useMemo, useState } from "react";
import {
    InvoiceViewOptionGroup,
    InvoiceViewOptions,
} from "@common/types/invoice";
import { InvoiceViewFilters } from "contexts/InvoicesViewContext";

/**
 * Context value for an invoices table that lives outside the Invoices page
 * (drilldown drawer, task body, task creation preview), satisfying the shape
 * the page provider has.
 */
export function useStandaloneInvoicesView() {
    const [filters, setFilters] = useState<InvoiceViewFilters | undefined>();
    const [viewOption, setViewOption] = useState<InvoiceViewOptions>({
        groupBy: InvoiceViewOptionGroup.INVOICE,
    });

    return useMemo(
        () => ({ filters, setFilters, viewOption, setViewOption }),
        [filters, viewOption],
    );
}
